import { Category } from '@bepatient/category-store';
import { Action } from '@ngrx/store';

export enum CategoryActionTypes {
  LOAD_CATEGORY = '[CategoryAction] Load category',
  LOAD_CATEGORY_FAILED = '[CategoryAction] Load category failed',
  LOAD_CATEGORY_SUCCESS = '[CategoryAction] Load category success'
}

export class CategoryActionLoadCategory implements Action {
  readonly type = CategoryActionTypes.LOAD_CATEGORY;
}

export class CategoryActionLoadCategoryFailed implements Action {
  readonly type = CategoryActionTypes.LOAD_CATEGORY_FAILED;
}

export class CategoryActionLoadCategorySuccess implements Action {
  readonly type = CategoryActionTypes.LOAD_CATEGORY_SUCCESS;

  constructor(public payload: Category) {}
}

export type CategoryActions =
  | CategoryActionLoadCategory
  | CategoryActionLoadCategoryFailed
  | CategoryActionLoadCategorySuccess;
